import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';

/* Actions */
import {
	getOrderDetails,
	saveOrderDetails,
	saveOriginalOrderDetails
} from '../../../redux/actions';

class ApproveReturns extends Component {

	constructor(props) {
		super(props);
		this.state = {
			sortBy: 'orderDate,desc',
			approveReturnsList: null
		};
	}

	componentWillMount() {
		const self = this;
		// redirect user to home page if he has not access to this page
		if(!self.props.isEmployeeHasAccessTo('Approve Returns')) {
			browserHistory.push('/home');
		}
		const { approveReturnsList } = self.props.state.order;
		if(!approveReturnsList) {
			self.props.fetchApproveReturnsList(null, response => {
				self.updateStateAndSort(response);
			});
		} else {
			self.updateStateAndSort(approveReturnsList);
		}
	}

	updateStateAndSort(approveReturnsList) {
		const self = this;
		approveReturnsList.responseObject = approveReturnsList.responseObject.filter(itm =>
			itm.orderHeader.orderSourceRef.indexOf('CTN') === 0 &&
			(!itm.orderHeader.holds || !itm.orderHeader.holds.hold || itm.orderHeader.holds.hold.length === 0) &&
			itm.orderDetail.orderLine.find(item => item.userItemDescription) &&
			itm.orderHeader.orderSource === 'CustomerNet'
			// && itm.orderHeader.attributes && itm.orderHeader.attributes.attribute.find(it => it.name === 'Attribute13' && it.value && it.value.toUpperCase() === 'NO')
		);
		self.setState({
			approveReturnsList
		}, () => {
			self.handleSortBy({ target: { value: self.state.sortBy } });
		});
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	handleSortBy(event) {
		let sortBy = event.target.value.split(',')[0],
			sortOrder = event.target.value.split(',')[1],
			{ approveReturnsList } = this.state,
			isAnyDateFilter = sortBy.indexOf('Date') !== -1;
		var self = this;
		approveReturnsList.responseObject = _.orderBy(approveReturnsList.responseObject, (e) => {
			return !isAnyDateFilter?e.orderHeader[sortBy]:self.props.formatDate(e.orderHeader[sortBy], 'MM/DD/YY')
		}, [sortOrder]);
		this.setState({
			sortBy: event.target.value,
			approveReturnsList,
		}, () => {
			// self.props.saveRequestReturnList(JSON.parse(JSON.stringify(approveReturnsList)));
		});
	}

	handleFetchOrderDetails(orderNumber, originalOrderNumber, wheretoRedirect, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			orderNumberGetDetailsCallCompleted: false,
			originalOrderNumberGetDetailsCallCompleted: false,
		}, () => {
			self.props.getOrderDetails('orderNumber='+originalOrderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					self.setState({
						originalOrderNumberGetDetailsCallCompleted: true,
						originalOrderNumberDetails: response,
					}, () => {
						self.saveAndRedirect(wheretoRedirect);
					});
				}
			}, false);
			self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					const {
						deliveryInstructions,
					} = response.responseObject;
					// if deliveryInstructions and it's starting from CreditOrderRef:CTN then current order is rebill order
					if(deliveryInstructions && deliveryInstructions.indexOf('CreditOrderRef:CTN') === 0) {
						// current details are of rebill order details
						self.setState({
							rebillOrderDetails: response,
							errorMessage: '',
						}, () => {
							const referenceNumber = deliveryInstructions.replace('CreditOrderRef:', '');
							self.fetchOtherOrderDetails('page=approveReturns&referenceNumber='+referenceNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (resp) => {
								if(resp.status && resp.responseObject) {
									const creditOrderDetails = {
										...resp,
										responseObject: {
											...resp.responseObject,
											rebillOrderDetails: self.state.rebillOrderDetails.responseObject,
										}
									};
									self.setState({
										orderNumberGetDetailsCallCompleted: true,
										orderNumberDetails: creditOrderDetails,
									}, () => {
										self.saveAndRedirect(wheretoRedirect);
									});
								} else {
									self.setState({
										errorMessage: 'Error occured while fetching order details.'
									});
								}
							});
						});
					}
					// else // if deliveryInstructions and it's starting from RebillOrderRef:CTN then current order is credit order
					else if (deliveryInstructions && deliveryInstructions.indexOf('RebillOrderRef:CTN') === 0) {
						// current details are of credit order details
						self.setState({
							creditOrderDetails: response,
							errorMessage: '',
						}, () => {
							const referenceNumber = deliveryInstructions.replace('RebillOrderRef:', '');
							self.fetchOtherOrderDetails('page=approveReturns&referenceNumber='+referenceNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (resp) => {
								if(resp.status && resp.responseObject) {
									const creditOrderDetails = {
										...self.state.creditOrderDetails,
										responseObject: {
											...self.state.creditOrderDetails.responseObject,
											rebillOrderDetails: resp.responseObject,
										}
									};
									self.setState({
										orderNumberGetDetailsCallCompleted: true,
										orderNumberDetails: creditOrderDetails,
									}, () => {
										self.saveAndRedirect(wheretoRedirect);
									});
								} else {
									self.setState({
										errorMessage: 'Error occured while fetching order details.'
									});
								}
							});
						});
					}
					// else its normal order
					else {
						self.setState({
							orderNumberGetDetailsCallCompleted: true,
							orderNumberDetails: response,
						}, () => {
							self.saveAndRedirect(wheretoRedirect);
						});
					}
				}
			}, false);
		});


	}

	saveAndRedirect(wheretoRedirect) {
		const self = this;
		const { orderNumberDetails, originalOrderNumberDetails, orderNumberGetDetailsCallCompleted, originalOrderNumberGetDetailsCallCompleted } = self.state;
		if (orderNumberGetDetailsCallCompleted === originalOrderNumberGetDetailsCallCompleted) {
			// update details with invoice number details from original order number details
			const originalItems = originalOrderNumberDetails.responseObject.items;
			self.props.saveOriginalOrderDetails(originalItems)
			orderNumberDetails.responseObject.items.forEach((item) => {
				const originalItem = originalItems.find(itm => itm.invoiceNumber === item.originalInvoiceNumber);
				const originalItemMatch = originalItems.find(itm => itm.item === item.item);
				//originalItemMatch && self.props.saveOriginalOrderDetails(originalItemMatch)
				if (originalItem && originalItem.invoiceDate) {
					item.invoiceDate = this.props.formatDate(originalItem.invoiceDate, 'MM/DD/YY');
				}
			});
			self.props.saveOrderDetails(orderNumberDetails);
			browserHistory.push('/' + wheretoRedirect);
		}
	}

	fetchOtherOrderDetails(queryString, callback) {
		const self = this;
		// make below line for order reference number
		self.props.getOrderDetails(queryString, (resp) => {
			if(!resp.status) {
				self.setState({
					errorMessage: resp.responseMessage
				})
			} else {
				callback(resp);
			}
		});
	}

    render() {
		const {
			approveReturnsList,
			errorMessage,
		} = this.state;
        return (
			<div>
		       <div className="push d-none d-sm-block">
		          	<h1 className="pageTitle">Approve Returns and Credits</h1>
		        </div>
				<div className="push d-block d-sm-none m-3">
		          	<h1 className="pageTitle">Approve Returns and Credits</h1>
		        </div>
				{errorMessage && <p className="bold red">{errorMessage}</p>}
				<div className="push d-none d-sm-block">
					<div className="captionAboveTable">
						<div className="columns">
							<div className="column column1">
								<big className="bold">{approveReturnsList && approveReturnsList.status && approveReturnsList.responseObject.length} Return Requests</big>
							</div>
							<div className="column column2 textRight">
								Sort by:&nbsp;
								<select onChange={this.handleSortBy.bind(this)} name="sortBy" defaultValue={this.state.sortBy}>
									<option value="orderNumber,desc">Request #</option>
									<option value="createdBy,desc">Entered By</option>
									<option value="createdDate,desc">Date Entered</option>
								</select>
							</div>
						</div>
					</div>
					<table className="dataTable viewReturnsTable">
						<thead>
							<tr>
								<th className="returnNumber">Request #</th>
								<th className="orderRef">Order Reference #</th>
								<th className="enteredBy">Entered By</th>
								<th className="origOrder">Original Order</th>
								<th className="dateEntered">Date Entered</th>
								<th className="returnStatus">Status</th>
								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							{this.state.approveReturnsList && this.state.approveReturnsList.status && this.state.approveReturnsList.responseObject.length === 0
								?<tr>
									<td colSpan={7}>No orders found meeting the specified criteria; please try your search again.</td>
								</tr>
								:null
							}
							{this.state.approveReturnsList && this.state.approveReturnsList.status && this.state.approveReturnsList.responseObject.length > 0 && this.state.approveReturnsList.responseObject.map((item, index) => {
								let { orderHeader } = item,
									{ orderLine } = item.orderDetail,
									enteredBy = "",
									{ attribute } = orderHeader.attributes;
								attribute = attribute?_.find(attribute, ['name', 'Attribute2']):null;
								if(attribute) {
									enteredBy = attribute.value;
								}
								let originalOrderNumber = '';
								// Added the below code as part of WCP-6942
								if(orderLine && orderLine.length) {
									orderLine.forEach(v => {
										if(v.returnAttribute1 && v.returnAttribute1 != undefined) {
											originalOrderNumber = v.returnAttribute1;
										}
									});
								}
								return <tr key={index}>
									<td className="returnNumber">
										<a className="bold" href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, originalOrderNumber, 'viewrequestsorderdetails')}>{orderHeader.orderNumber}</a>
									</td>
									<td>
										{orderHeader.orderSourceRef}
									</td>
									<td className="enteredBy">
										{enteredBy}
									</td>
									<td>
										{originalOrderNumber}
									</td>
									<td className="dateEntered">
										{this.props.formatDate(orderHeader.createdDate, 'MM/DD/YY')}
									</td>
									<td className="returnStatus">
										{orderHeader.orderStatus}
									</td>
									<td className="textCenter">
										<a href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, originalOrderNumber, 'approvereturncreditrequest')}>Review</a>
									</td>
								</tr>
							})}
						</tbody>
					</table>
				</div>
				<div className="push d-block d-sm-none m-3">
					<div className="captionAboveTable">
							<div>
								<div className="bold big">{approveReturnsList && approveReturnsList.status && approveReturnsList.responseObject.length} Return Requests</div>
							</div>
							{/*  */}
					</div>
					<div style={{backgroundColor:"#f3f3f3"}}>
						<form className="manageOrdersSortBy p-3" name="AROrdersSortBy" id="AROrdersSortBy">
							<label>
								Sort by:&nbsp;
								<select onChange={this.handleSortBy.bind(this)} name="sortBy"
								 style={{padding:"0.5rem", width:"14rem",borderRadius:"10px" }}
								 defaultValue={this.state.sortBy}>
									<option value="orderNumber,desc">Request #</option>
									<option value="createdBy,desc">Entered By</option>
									<option value="createdDate,desc">Date Entered</option>
								</select>
							</label>
						</form>
					</div>
					{this.state.approveReturnsList && this.state.approveReturnsList.status && this.state.approveReturnsList.responseObject.length === 0
								?<tr>
									<td colSpan={7}>No orders found meeting the specified criteria; please try your search again.</td>
								</tr>
								:null
							}
							{this.state.approveReturnsList && this.state.approveReturnsList.status && this.state.approveReturnsList.responseObject.length > 0 && this.state.approveReturnsList.responseObject.map((item, index) => {
								let { orderHeader } = item,
									{ orderLine } = item.orderDetail,
									enteredBy = "",
									{ attribute } = orderHeader.attributes;
								attribute = attribute?_.find(attribute, ['name', 'Attribute2']):null;
								if(attribute) {
									enteredBy = attribute.value;
								}
								let originalOrderNumber = '';
								// Added the below code as part of WCP-6942
								if(orderLine && orderLine.length) {
									orderLine.forEach(v => {
										if(v.returnAttribute1 && v.returnAttribute1 != undefined) {
											originalOrderNumber = v.returnAttribute1;
										}
									});
								}
								return  <div className="accordion accordion-borderless" id={`accordionApproveReturns${index}`}  key={index}>
								<div>
								<h2 className="accordion-header" id={`flush-ApproveReturns${index}`}>
								<button className="accordion-button  mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseApproveReturns${index}`} aria-expanded="true" aria-controls={`flush-collapseApproveReturns${index}`}>
										{`REQUEST # `}<a className="bold ps-3" href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, originalOrderNumber, 'viewrequestsorderdetails')}>{orderHeader.orderNumber}</a><br/>
									</button>
									</h2>
									<div id={`flush-collapseApproveReturns${index}`} className="accordion-collapse collapse show" aria-labelledby={`flush-ApproveReturns${index}`} data-bs-parent={`#accordionApproveReturns${index}`}>
									<table className='orderTable'>
										<tbody>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>ORDER REFERENCE #</td>
												<td>{orderHeader.orderSourceRef}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>ENTERED BY</td>
												<td className="enteredBy">{enteredBy}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>ORIGINAL ORDER</td>
												<td>{originalOrderNumber}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>DATE ENTERED</td>
												<td className="dateEntered">{this.props.formatDate(orderHeader.createdDate, 'MM/DD/YY')}</td>
											</tr>
											<tr className='border-bottom'>
												<td className='p-3 fw-bold'>STATUS</td>
												<td className="returnStatus">{orderHeader.orderStatus}</td>
											</tr>
											<tr>
												<td>{` `}</td>
												<td className="py-3">	<a href="" onClick={this.handleFetchOrderDetails.bind(this, orderHeader.orderNumber, originalOrderNumber, 'approvereturncreditrequest')}>Review</a>	</td>
											</tr>
										</tbody>
									</table>
								</div>
								</div>
							</div>
							})}
				</div>
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderDetails: (queryStringParams, callback, saveToStore) => dispatch(getOrderDetails(queryStringParams, callback, saveToStore)),
	saveOrderDetails: (data) => dispatch(saveOrderDetails(data)),
	saveOriginalOrderDetails: (data) => dispatch(saveOriginalOrderDetails(data)),
});

ApproveReturns = connect(mapStateToProps, mapDispatchToProps)(ApproveReturns);
export default ApproveReturns;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/approveReturns.js